var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.818237H7.54545C6.46048 0.818237 5.41994 1.24924 4.65274 2.01644C3.88555 2.78363 3.45455 3.82417 3.45455 4.90915V7.36369H1V10.6364H3.45455V17.1819H6.72727V10.6364H9.18182L10 7.36369H6.72727V4.90915C6.72727 4.69215 6.81347 4.48404 6.96691 4.3306C7.12035 4.17717 7.32846 4.09096 7.54545 4.09096H10V0.818237Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8ecd76f8fcfd4366b7932b3c5da18a3a.svg";
export { ForwardRef as ReactComponent };